import React from 'react';
import { Container } from '@pixi/react';

import { jackPotStore } from '../../../store/jackPotStore';

import JackPotInfo from './jackPotInfo';

function JackPot({ containerConfig }) {
  const { hasJackPot } = jackPotStore;
  if (!hasJackPot) return null;

  return (
    <Container {...containerConfig} name='JackPotContainer'>
      <JackPotInfo />
    </Container>
  );
}

export default JackPot;
